<template>

<v-dialog v-model="dialog" width="800px">
  <v-card>
    <p class=".title ma-2">Online payments /  pay.nl</p>
    <v-form ref="showHobo">

     <table cellspacing="20">
       <tr>
       <td>Date / Time</td>  
       <td>State</td>
       <td>Method</td>
       <td>Pay NL transaction ID</td>
       <td align="right">Amount</td>
     </tr>   

    <tbody v-for="(hoboRecord,i) in hobo.hobo" :key="i">
    <tr>
       <td> {{hoboRecord.hobo_dt}}</td>
       <td> {{hoboRecord.hobo_stat}}</td>
       <td> {{hoboRecord.hobo_methode_oms}}</td>      
       <td> {{hoboRecord.hobo_paynl_transactionId}}</td>
       <td align="right"> {{hoboRecord.hobo_bedrag}}</td>
       <td v-if="hoboRecord.hobo_refund == 'Yes' && hoboRecord.hobo_refund_allowed == 'Yes'" ><v-btn color="primary"  small @click="refund(hoboRecord.hobo_encrid)">Refund</v-btn></td>
     </tr>
       <tr v-for="(hobrRecord,j) in hoboRecord.hobr" :key="j">
           <td>{{hobrRecord.hobr_dt}}</td>
           <td>Refund</td>
           <td>{{hoboRecord.hobo_methode_oms}}</td>
           <td> {{hoboRecord.hobo_paynl_transactionId}} </td>
           <td align="right"> {{hobrRecord.hobr_bedrag}}</td>
       </tr>  
    </tbody>
     </table> 
     <addHobr ref="addHobr"></addHobr>

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
import addHobr from "@/views/huov/hobo/addHobr.vue";
export default {
  components: {
    addHobr,
  },  
  data() { 
    return {
      dialog: false,
      huov_encrid: null,
      hobo: {}
    }
  },
  methods: {
    open(huov_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.huov_encrid = huov_encrid;
      this.$axios
        .post("ares/json/ares/huov/hobo/getHobo.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHobo"
          },
          getHobo: {
            huov_encrid: huov_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hobo = res.data.getHobo;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    refund(hobo_encrid) {
       this.$refs.addHobr.open(hobo_encrid);
    },
  }
}
</script>

